import { loadStripe, type Stripe } from '@stripe/stripe-js';

const stripeInstanceCache = new Map<string, Promise<Stripe | null>>();

export function getStripeInstance(stripeAccountId?: string | null): Promise<Stripe | null> {
  const publishableKey = (import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined) ?? '';
  if (!publishableKey) {
    return Promise.resolve(null);
  }

  const cacheKey = `${publishableKey}:${stripeAccountId || 'platform'}`;
  const cached = stripeInstanceCache.get(cacheKey);
  if (cached) {
    return cached;
  }
  // Drop rejected loads from the cache so a transient failure (ad blocker
  // toggle, network blip) doesn't poison Stripe for the rest of the tab.
  const loading = loadStripe(
    publishableKey,
    stripeAccountId ? { stripeAccount: stripeAccountId } : undefined,
  ).catch((error: unknown) => {
    stripeInstanceCache.delete(cacheKey);
    throw error;
  });
  stripeInstanceCache.set(cacheKey, loading);
  return loading;
}
